import { FieldData } from "./customFieltType";




export function convertArray(arr: FieldData[]) {
  return arr
    .filter(item => item.autocompleteValue)
    .map(item => ({
      key: item.autocompleteValue!.label,
      value: item.value ?? item.textValue,
      customFieldId: item.customFieldId,   
      required: item.required,
      isUnique: item.isUnique,
      label: item.label,
    }))
    .filter((item) => item.value !== "");
}


export const setInitialCustomFiels = (data: any[]) => {
  return data.map((item: any, i: number) => ({
    id: String(i + 1),
    autocompleteValue: {
      id: i + 1,
      label: item.fieldName,
      required: item.required,
      customFieldId: item._id,  
      isUnique: item.isUnique, 
    },
    textValue: "",
    label: item.fieldName,
    value: "",
    required: item.required,
    customFieldId: item._id,
    isUnique: item.isUnique,      
  }))
}